import StoreLocator from "../components/storelocatorpage";

export default StoreLocator;
